import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  attributesQueryOptions,
  productTypesQueryOptions,
  skuRulesQueryOptions,
  SkuRulesPage,
} from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/sku-rules/new')({
  staticData: { crumb: 'skuRules:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'attributes.write');
  },
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.query({ ...attributesQueryOptions(), staleTime: 'static' }),
      context.queryClient.query({ ...productTypesQueryOptions(), staleTime: 'static' }),
      context.queryClient.query({ ...skuRulesQueryOptions(), staleTime: 'static' }),
    ]).catch(() => undefined),
  component: () => <SkuRulesPage view="new" />,
});
